/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignStatusCheckPathParams, CampaignStatusCheckResponse } from '../types/CampaignStatusCheck'

/**
 * GET /campaigns/:campaign/check
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignStatusController.php CampaignStatusController::check
 */
export async function campaignStatusCheck(
	campaign: CampaignStatusCheckPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignStatusCheckResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/check`, config)
}
